import { jsx as l } from "react/jsx-runtime";
import { AdvancedMarker as o } from "@vis.gl/react-google-maps";
import u from "./map-cluster-wrapper.module.less.js";
import { useCallback as i } from "react";
import { ClusterMarker as s } from "../cluster-marker/cluster-marker.js";
const b = ({
  position: e,
  title: c,
  clusterId: a,
  withoutAdvancedMarker: p,
  stationsInClusterByType: f,
  onClickMarker: m
}) => {
  const t = i(
    () => m && m(a, e),
    [m, a, e]
  ), n = /* @__PURE__ */ l("div", { className: u.wrapper, children: f.map((r) => /* @__PURE__ */ l(
    s,
    {
      markerType: r.markerType,
      numberOfStations: r.numberOfStations,
      hasElectricalCharging: r.hasElectricalCharging
    },
    r.markerType
  )) });
  return p ? n : /* @__PURE__ */ l(o, { title: c, onClick: t, position: e, children: n }, a);
};
export {
  b as MapClusterWrapper,
  b as default
};
